import PubSub from "underpub-js";
import gsap from "gsap";
import ImgixClient from "@imgix/js-core";

const client = new ImgixClient({
  domain: 'amplify-harperscov.imgix.net',
});

var ModalLot = function (options) {

  this.options = {
    $el: false,
    baseClass: 'mol-ModalLot',
    isToggled: false,
  };

  $.extend(true, this.options, options);

};

ModalLot.prototype.init = function () {

  const self = this;

  self.$inner = self.options.$el.find(`.${self.options.baseClass}__inner`);
  self.$error = self.options.$el.find(`.${self.options.baseClass}__error`);
  self.$container = self.options.$el.find(`.${self.options.baseClass}__container`);
  self.$loader = self.options.$el.find(`.${self.options.baseClass}__loader`);
  self.$loaderIcon = self.options.$el.find(`.${self.options.baseClass}__loader__icon`);
  self.dataContainerAttribute = "data-modal-lot-data-container";
  self.$dataContainers = self.options.$el.find(`[${self.dataContainerAttribute}]`);

  self.initAnimation();

  /*
  $('[data-modal-lot-show]').on('click', (e) => {
    const lotId = $(e.currentTarget).data("modal-lot-lot-id");
    self.toggleOn();

    if (typeof lotId == "number") {
      self.fetchData(lotId);
    }
  });
  $('[data-modal-lot-hide]').on('click', () => self.toggleOff());
  */

};

ModalLot.prototype.resetData = function () {
  const self = this;

  self.$dataContainers.attr(self.dataContainerAttribute, "inactive");

  self.$dataContainers.each((index, element) => {
    const $dataContainer = $(element);

    if (!$dataContainer.children().length) {
      $dataContainer.text("");
    }

    if ($dataContainer.find(".el-Carousel").length) {
      PubSub.publish('Carousel:updateData', {
        container: $dataContainer,
        reset: true
      })
    }

    if ($dataContainer.children("li").not("[data-modal-lot-data-container]").length) {
      $dataContainer.children("li").not("[data-modal-lot-data-container]").remove();
    }
  });
}

ModalLot.prototype.loadData = function (lotData) {
  const self = this;

  self.$error.attr(self.dataContainerAttribute, "inactive");
  self.$container.attr(self.dataContainerAttribute, "");

  self.$address = self.options.$el.find(`[data-modal-lot-address]`);
  self.$amenities = self.options.$el.find(`[data-modal-lot-amenities]`);
  self.$availability = self.options.$el.find(`[data-modal-lot-availability]`);
  self.$bedrooms = self.options.$el.find(`[data-modal-lot-bedrooms]`);
  self.$bathrooms = self.options.$el.find(`[data-modal-lot-bathrooms]`);
  self.$dockAvailable = self.options.$el.find(`[data-modal-villa-dockavailable]`);
  self.$cost = self.options.$el.find(`[data-modal-lot-cost]`);
  self.$description = self.options.$el.find(`[data-modal-lot-description]`);
  self.$floorplanImage = self.options.$el.find(`[data-modal-lot-floorplan-image]`);
  self.$heading = self.options.$el.find(`[data-modal-lot-heading]`);
  self.$images = self.options.$el.find(`[data-modal-lot-images]`);
  self.$intro = self.options.$el.find(`[data-modal-lot-intro]`);
  self.$petPolicies = self.options.$el.find(`[data-modal-lot-petPolicies]`);
  self.$pdf = self.options.$el.find(`[data-modal-lot-pdf]`);
  self.$squareFeet = self.options.$el.find(`[data-modal-lot-squarefeet]`);
  self.$lakeshoreFrontage = self.options.$el.find(`[data-modal-lot-lakeshorefrontage]`);
  self.$streetFrontage = self.options.$el.find(`[data-modal-lot-streetfrontage]`);
  self.$setbackDistance = self.options.$el.find(`[data-modal-lot-setbackdistance]`);

  const lotType = lotData.lotType;
  const address = lotData.address || lotType.address;
  const amenities = lotData.amenities.length ? lotData.amenities : lotType.amenities.length ? lotType.amenities : [];
  const applicationUrl = lotData.applicationUrl || lotType.applicationUrl;
  const availability = lotData.availability;
  const bathrooms = lotData.bathrooms || lotType.bathrooms;
  const bedrooms = lotData.bedrooms || lotType.bedrooms;
  const dockAvailable = lotData.dockAvailable;
  const cost = lotData.cost || lotType.cost;
  const description = lotData.description || lotType.description;
  const images = lotData.images.length ? lotData.images : lotType.images.length ? lotType.images : [];
  const intro = lotData.intro || lotType.intro;
  const isAvailable = lotData.isAvailable;
  const petPolicies = lotData.petPolicies.length ? lotData.petPolicies : lotType.petPolicies.length ? lotType.petPolicies : [];
  const pdf = lotData.pdf || lotType.pdf;
  const squareFeet = lotData.squareFeet || lotType.squareFeet;
  const lakeshoreFrontage = lotData.lakeshoreFrontage || lotType.lakeshoreFrontage;
  const streetFrontage = lotData.streetFrontage || lotType.streetFrontage;
  const setbackDistance = lotData.setbackDistance || lotType.setbackDistance;
  const title = lotData.title;
  const youtubeVideoId = lotData.youtubeVideoId || lotType.youtubeVideoId;
  let floorPlanImage;

  if (lotType.floorPlanImage && lotType.floorPlanImage.length) {
    floorPlanImage = lotType.floorPlanImage[0];
  }

  const showDataContainer = element => {
    $(element).attr(self.dataContainerAttribute, "");
    $(element).parents(`[${self.dataContainerAttribute}]`).attr(self.dataContainerAttribute, "");
  }

  if (title && title.length) {
    self.$heading.text(title);
    showDataContainer(self.$heading);
  }

  if (cost && cost.length) {
    self.$cost.text(cost);
    showDataContainer(self.$cost);
  }

  if (bedrooms && bedrooms.length) {
    self.$bedrooms.text(isNaN(bedrooms) ? bedrooms : `${bedrooms} bd`);
    showDataContainer(self.$bedrooms);
  }

  if (bathrooms && bathrooms.length) {
    self.$bathrooms.text(`${bathrooms} ba`);
    showDataContainer(self.$bathrooms);
  }

  if (dockAvailable) {
    showDataContainer(self.$dockAvailable);
  }

  if (description && description.length) {
    self.$description.html(description);
    showDataContainer(self.$description);
  }

  if (squareFeet && squareFeet.length) {
    self.$squareFeet.text(`${squareFeet} sqft.`);
    showDataContainer(self.$squareFeet);
  }

  if (lakeshoreFrontage && lakeshoreFrontage.length) {
    self.$lakeshoreFrontage.text(`${lakeshoreFrontage} ft. lakeshore frontage`);
    showDataContainer(self.$lakeshoreFrontage);
  }

  if (streetFrontage && streetFrontage.length) {
    self.$streetFrontage.text(`${streetFrontage} ft. street frontage`);
    showDataContainer(self.$streetFrontage);
  }

  if (setbackDistance && setbackDistance.length) {
    self.$setbackDistance.text(`${setbackDistance} ft. setback distance`);
    showDataContainer(self.$setbackDistance);
  }

  if (intro && intro.length) {
    self.$intro.html(intro);
    showDataContainer(self.$intro);
  }

  if (address && address.length) {
    self.$address.text(address);
    showDataContainer(self.$address);
  }

  let availabilityText = "";

  if (isAvailable == true) {
    availabilityText = "Available";

    if (availability && typeof availability == "string" && availability.length > 0) {
      availabilityText += ` ${availability}`;
    }
  } else {
    availabilityText = "Unavailable";
  }

  if (availabilityText && availabilityText.length) {
    self.$availability.text(availabilityText);
    showDataContainer(self.$availability);
  }

  if (amenities && amenities.length) {
    showDataContainer(self.$amenities);

    amenities.forEach(amenity => {
      const amenityCopy = amenity.copy;
      self.$amenities.append(`<li>${amenityCopy}</li>`)
    })
  }

  if (petPolicies && petPolicies.length) {
    showDataContainer(self.$petPolicies);

    petPolicies.forEach(petPolicy => {
      const petPolicyCopy = petPolicy.copy;
      self.$petPolicies.append(`<li>${petPolicyCopy}</li>`)
    })
  }

  if (floorPlanImage) {
    let floorPlanImageUrl = floorPlanImage.url;
    const floorPlanImageAlt = floorPlanImage.alt;
    const floorPlanImageFocalPoint = floorPlanImage.focalPoint;
    const floorPlanImagePath = floorPlanImage.path;

    if (floorPlanImageFocalPoint && floorPlanImageFocalPoint.length && floorPlanImagePath && floorPlanImagePath.length) {
      const floorPlanImageX = floorPlanImageFocalPoint[0] || .5;
      const floorPlanImageY = floorPlanImageFocalPoint[1] || .5;
      const imgixFloorPlanImageUrl = client.buildURL(`/images/${floorPlanImagePath}`, {
        width: 900,
        "fp-x": floorPlanImageX,
        "fp-y": floorPlanImageY,
      })

      if (imgixFloorPlanImageUrl && imgixFloorPlanImageUrl.length) {
        floorPlanImageUrl = imgixFloorPlanImageUrl;
      }
    }

    if (floorPlanImageUrl.length) {
      self.$floorplanImage.html(`<img src="${floorPlanImageUrl} alt="${floorPlanImageAlt} />`)

      showDataContainer(self.$floorplanImage);
    }
  }

  if ((images && images.length) || (youtubeVideoId && youtubeVideoId.length)) {
    showDataContainer(self.$images);

    const slides = [];

    if (images && images.length) {
      images.forEach(image => {
        let imageUrl = image.url;
        const imageAlt = image.title;
        const imageFocalPoint = image.focalPoint;
        const imagePath = image.path;

        if (imageFocalPoint && imageFocalPoint.length && imagePath && imagePath.length) {
          const imageX = imageFocalPoint[0] || .5;
          const imageY = imageFocalPoint[1] || .5;
          const imgixImageUrl = client.buildURL(`/images/${imagePath}`, {
            width: 900,
            ar: 16 / 9,
            fit: "crop",
            "fp-x": imageX,
            "fp-y": imageY,
          })

          if (imgixImageUrl && imgixImageUrl.length) {
            imageUrl = imgixImageUrl;
          }
        }

        if (imageUrl.length) {
          slides.push({
            type: "image",
            url: imageUrl,
            alt: imageAlt,
          })
        }
      });
    }

    if (youtubeVideoId && youtubeVideoId.length) {
      const videoUrl = `https://www.youtube.com/embed/${youtubeVideoId}?origin=https://plyr.io&iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1`;

      slides.push({
        type: "video",
        url: videoUrl,
      })
    }

    if (pdf && pdf.length) {
      const pdfUrl = pdf[0].url;

      if (!pdfUrl.length) return;

      showDataContainer(self.$pdf);

      self.$pdf.find("a").attr("href", pdfUrl);

    }

    PubSub.publish('Carousel:updateData', {
      container: self.$images,
      slides
    })
  }

  self.$form = $("[data-modal-lot-form]");

  if (self.$form.length && isAvailable == true) {
    showDataContainer(self.$form);

    // Hidden fields are populated on submit to prevent browser detecting form changes and displaying an alert popup.
    self.$form.on('onBeforeFormieSubmit', () => {
      const $fieldLot = self.$form.find(`[name="fields[lot]`);
      const $fieldLotType = self.$form.find(`[name="fields[lotType]`);
      const $fieldApplicationUrl = self.$form.find(`[name="fields[applicationUrl]"]`);

      if ($fieldLot.length && (title && title.length)) {
        $fieldLot.val(title);
      }

      if ($fieldLotType.length && (lotType.title && lotType.title.length)) {
        $fieldLotType.val(lotType.title);
      }

      if ($fieldApplicationUrl.length && (applicationUrl && applicationUrl.length)) {
        $fieldApplicationUrl.val(applicationUrl);
      }
    })
  }

  self.loadedTimeout = setTimeout(() => {
    self.loadedTimeline.restart();
  }, 1000);
}

ModalLot.prototype.fetchData = function (lotId) {
  const self = this;

  if (typeof lotId != "number") return;

  const lotQuery = `query MyQuery {
    entry(section: "lots", id: "${lotId}") {
      ... on lots_lot_Entry {
        id
        url
        title
        address: lot_address
        applicationUrl: lot_applicationUrl
        availability:lot_availability
        bedrooms:lot_bedrooms
        bathrooms: lot_bathrooms
		dockAvailable: lot_dockAvailable
        cost:lot_cost
        description:lot_description
        intro: lot_intro
        isAvailable: lot_isAvailable
        securityDeposit: lot_securityDeposit
        squareFeet: lot_squareFeet
        lakeshoreFrontage: lot_lakeshoreFrontage
        streetFrontage: lot_streetFrontage
        setbackDistance: lot_setbackDistance
        petPolicies:lot_petPolicies {
          ... on lot_petPolicies_petPolicy_BlockType {
            copy:petPolicy_copy
          }
        }
        amenities:lot_amenities {
          ... on lot_amenities_amenity_BlockType {
            copy:amenity_copy
          }
        }
        youtubeVideoId:lot_youtubeVideoId
        images:lot_images {
          title
          url @transform(width: 1600, height: 900, immediately: true)
          focalPoint
          path
        }
        pdf:lot_pdf(limit:1) {
          url
        }
        lotType:lot_lotType {
          ...on lotTypes_lotType_Entry {
            title
            address: lot_address
            applicationUrl: lot_applicationUrl
            bedrooms: lot_bedrooms
            bathrooms: lot_bathrooms
            cost: lot_cost
            description: lot_description
            intro: lot_intro
            securityDeposit: lot_securityDeposit
            squareFeet: lot_squareFeet
            lakeshoreFrontage: lot_lakeshoreFrontage
            streetFrontage: lot_streetFrontage
            setbackDistance: lot_setbackDistance
            petPolicies: lot_petPolicies {
              ...on lot_petPolicies_petPolicy_BlockType {
                copy: petPolicy_copy
              }
            }
            amenities: lot_amenities {
              ...on lot_amenities_amenity_BlockType {
                copy: amenity_copy
              }
            }
            youtubeVideoId: lot_youtubeVideoId
            images: lot_images {
              title
              url @transform(width: 1600, height: 900, immediately: true)
              focalPoint
              path
            }
            floorPlanImage: lotType_floorPlanImage(limit: 1) {
              title
              url @transform(width: 1600, height: 900, immediately: true)
              focalPoint
              path
            }
            pdf: lot_pdf(limit: 1) {
              url
            }
          }
        }
      }
    }
  }`;

  $.ajax({
    type: 'POST',
    url: '/api',
    data: {
      query: lotQuery
    },
    success: (data) => {
      if (typeof data.data == "undefined") {
        console.log('There was an error loading lot details.', data);
        self.displayError();
        return;
      }

      const lotData = data.data.entry;

      if (!lotData) {
        self.displayError();
        return;
      }

      if (lotData.lotType.length) {
        lotData.lotType = lotData.lotType[0];
      }

      self.loadData(lotData);
    },
    error: (data) => {
      self.displayError();
      console.log('There was an error loading lot details.', data);
    },
  });
}

ModalLot.prototype.displayError = function (heading, copy) {
  const self = this;

  self.loadedTimeout = setTimeout(() => {
    self.loadedTimeline.restart();
  }, 1000);

  self.$error.attr(self.dataContainerAttribute, "");
  self.$container.attr(self.dataContainerAttribute, "inactive");

}

ModalLot.prototype.initAnimation = function () {
  const self = this;

  const getContentHeightTween = () => gsap.fromTo(self.$container, {
    height: 0
  }, {
    duration: .6,
    ease: "expo.out",
    height: "auto"
  });

  self.loaderIconSpinningTimeline = gsap.timeline({
    paused: true
  }).to(
    self.$loaderIcon, {
      rotation: 360,
      duration: .6,
      repeat: -1,
    }, "<.2"
  )

  self.timeline = gsap
    .timeline({
      paused: true,
      reversed: true,
      defaults: {
        ease: "expo.out",
        duration: .4,
      },
      onComplete: () => {
        self.toggleState();
      },
      onReverseComplete: () => {
        self.toggleState();
        self.resetData();
        clearTimeout(self.loadedTimeout);
        self.loaderIconSpinningTimeline.pause(0);
        self.loadedTimeline.pause(0);
        gsap.set([self.$container, self.$error, self.$loader, self.$loaderIcon], {
          clearProps: "all"
        });
      },
    })
    .set([self.$container, self.$error, self.$loader, self.$loaderIcon], {
      clearProps: "all"
    })
    .set(self.$loaderIcon, {
      opacity: 0,
      scale: 0,
    })
    .set(self.options.$el, {
      visibility: "visible",
    })
    .fromTo(self.options.$el, {
      opacity: 0
    }, {
      opacity: 1,
    })
    .from(self.$inner, {
      y: 20,
      opacity: 0,
    }, "<.2")
    .to(self.$loaderIcon, {
      scale: 1,
      opacity: 1,
      ease: "back.out(1.5)",
      duration: .3,
      delay: .1,
    }, "<")
    .add(() => self.loaderIconSpinningTimeline.play(), "<");

  self.loadedTimeline = gsap.timeline({
      paused: true,
      defaults: {
        ease: "expo.out",
        duration: .6,
      }
    })
    .add(() => self.loaderIconSpinningTimeline.pause(0))
    .call(getContentHeightTween)
    .to(self.$loaderIcon, {
      opacity: 0,
      scale: 0,
      duration: .4,
    })
    .to(self.$loader, {
      opacity: 0,
      visibility: "hidden",
    })
    .fromTo([self.$error, self.$container], {
      opacity: 0
    }, {
      opacity: 1
    }, "<")
};

ModalLot.prototype.toggleState = function () {
  const self = this;

  self.options.isToggled = !self.options.isToggled;
};

ModalLot.prototype.toggleOn = function (speed = 1) {
  const self = this;

  if (self.options.isToggled || self.timeline.isActive()) return;

  self.timeline.timeScale(speed).play();
};

ModalLot.prototype.toggleOff = function (speed = 3) {
  const self = this;

  if (!self.options.isToggled || self.timeline.isActive()) return;

  self.timeline.timeScale(speed).reverse(0);
};

ModalLot.prototype.toggle = function () {
  const self = this;

  self.timeline.reversed() ? self.toggleOn() : self.toggleOff();
};

export default ModalLot;